import { useServers } from "./useServers";

// Mantiene la misma forma que antes ({ has_server }) para las pantallas que ya lo usan.
export function useServerStatus(projectId) {
  const query = useServers(projectId);
  return { ...query, data: query.data ? { has_server: query.data.length > 0, servers: query.data } : undefined };
}
